// extracted by mini-css-extract-plugin
export default {"tr":"SkeletonTable_tr__mPK64","field":"SkeletonTable_field__dubwO","thead":"SkeletonTable_thead__ujdI7"};